<template>
    <div class="wrap full-h">
        <div class="left full-h" style="height: calc(100vh - 130px);">
            <div class="level1-wrap" v-loading="level1Loading">
                <div v-for="item in level1List">
                    <h3 class="level-title">{{item.name}}</h3>
                    <p v-if="!item.children||item.children.length<=0" class="tac text-color-gray"> 暂无数据</p>
                    <template v-else>
                        <p class="pl10 pr20 relative level-item pointer ellipsis" :class="activeLevel1Tag.id==inner.id?'active':''" v-for="inner in item.children" @click="changeLevel1Tag(item,inner)">
                            <span :title="inner.name">{{inner.name}}</span>
                            <span v-if="pageFuncNames.includes('edit_level1_tag')" class="edit-icon el-icon-edit-outline text-color-primary font14px" @click.stop="editLevel1Tag(item,inner)"></span>
                        </p>
                    </template>
                </div>
            </div>
        </div>
        <div class="right pl10 full-h" style="height: calc(100vh - 130px);">
            <div class="filter-bar mb10">
                <el-form :inline="true" @submit.native.prevent="submitSearch">
                    <el-form-item label="子标签名称：">
                        <el-input v-model="tempQuery.search" @keyup.enter.native="submitSearch" @clear="submitSearch" clearable placeholder="请输入子标签名称关键字搜索" style="width: 250px;">
                            <el-button slot="append" icon="el-icon-search" @click="submitSearch"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="创建人：">
                        <ESelect v-model="queryData.creator" @change="submitSearch" filterable collapse-tags clearable placeholder="搜索或下拉选择" style="width: 150px;">
                            <el-option v-for="item in creatorList" :label="item.name" :value="item.id" :key="item.id">
                                {{item.name}}
                            </el-option>
                        </ESelect>
                    </el-form-item>
                </el-form>
            </div>
            <div class="table-tool-bar clear-both mb10">
                <div class="fl">
                    <el-button type="primary" v-if="pageFuncNames.includes('add_level2_tag')" @click="showAddLevel2TagModal"  size="mini" class="mr20" v-matomo="{behaviorCategory: '标签管理(标签维护)', event: '点击',  name: '添加子标签' }">添加子标签</el-button>
                </div>
            </div>
            <div class="data-list mb20">
                <div style="position: relative; flex: 1 1 0;">
                    <div class="table-wrap" style="position: absolute; width: 100%;">
                        <el-table
                            ref="dataTable"
                            :data="dataList"
                            v-loading="dataLoading||level1Loading"
                            tooltip-effect="dark"
                            :header-cell-style="{background:'#e8eaec',color:'#333'}"
                            :height="tableHeight"
                            stripe
                            style="width: 100%;">
                            <el-table-column
                                fixed="left"
                                prop="index"
                                label="序号"
                                width="90">
                            </el-table-column>
                            <el-table-column
                                fixed="left"
                                prop="name"
                                label="子标签"
                                show-overflow-tooltip
                                min-width="170">
                            </el-table-column>
                            <el-table-column
                                fixed="right"
                                prop="action"
                                align="center"
                                label="操作"
                                min-width="120">
                                <template slot-scope="scope">
                                    <span v-if="pageFuncNames.includes('edit_level2_tag')" class="el-icon-edit-outline text-color-primary font14px pointer action-btn" @click="editLevel2Tag(scope.row)" title="编辑" v-matomo="{behaviorCategory: '标签管理(标签维护)', event: '点击',  name: '编辑子标签' }"></span>

                                    <el-popconfirm
                                        v-if="pageFuncNames.includes('del_level2_tag')"
                                        placement="top"
                                        icon="el-icon-info"
                                        icon-color="red"
                                        confirm-button-type="danger"
                                        title="确认要删除吗？删除后已应用该子标签的内容将删除，并且不可恢复！"
                                        @confirm="delLevel2Tag(scope.row)"
                                        @cancel="cancelDelLevel2Tag"
                                    >
                                        <span slot="reference" class="el-icon-delete text-color-error font14px font14px pointer action-btn" title="删除" v-matomo="{behaviorCategory: '标签管理(标签维护)', event: '点击',  name: '删除子标签' }"></span>
                                    </el-popconfirm>

                                    <span v-if="!pageFuncNames.includes('del_level2_tag')&&!pageFuncNames.includes('edit_level2_tag')">-</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="dimension_name"
                                label="标签归属"
                                min-width="90">
                            </el-table-column>
                            <el-table-column
                                prop="level1_name"
                                label="父标签"
                                min-width="140">
                                <template slot-scope="scope">
                                    <p class="text-nowrap">{{scope.row.level1_name||'--'}}</p>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="editor"
                                label="最新编辑人"
                                min-width="100">
                            </el-table-column>
                            <el-table-column
                                prop="edit_time"
                                label="最新编辑时间"
                                min-width="140">
                            </el-table-column>
                            <el-table-column
                                prop="creator"
                                label="创建人"
                                min-width="100">
                            </el-table-column>
                            <el-table-column
                                prop="create_time"
                                label="创建时间"
                                min-width="140">
                            </el-table-column>
                        </el-table>
                        <div class="page-bar tac mt10">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page.sync="queryData.pn"
                                :page-sizes="[30, 50,100]"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalCnt">
                            </el-pagination>
                        </div>
                    </div>

                </div>

            </div>

            <EditLevel1TagModal ref="editLevel1TagModal" :data="actionLevel1Tag" @update="updateLevel1Tag"/>
            <AddLevel2TagModal ref="addLevel2TagModal" :data="activeLevel1Tag" @update="getDataList"/>
            <EditLevel2TagModal ref="editLevel2TagModal" :data="activeLevel2Tag" @update="getDataList"/>
        </div>
    </div>
</template>

<script>
    import EditLevel1TagModal from '../modal/eidtLevel1TagModal';
    import AddLevel2TagModal from '../modal/addLevel2TagModal.vue';
    import EditLevel2TagModal from '../modal/editLevel2TagModal.vue';
    import API from '@/api/baseInfo/tag.js';
    import matomoFun from "@/utils/matomo.js";
    import { ESelect } from '@/components/Ele/eSelect';

    export default {
        name: "TagPage",
        components:{
            AddLevel2TagModal,
            EditLevel1TagModal,
            EditLevel2TagModal,
            ESelect,
        },
        props:["pageFuncNames","pageFields"],
        data(){
            return {
                level1List:[],
                level1Loading:false,
                dataLoading:false,
                activeLevel1Tag:{},     //当前选中的一级标签
                activeLevel2Tag:{},
                tempQuery:{
                    search:'',
                },
                queryData:{
                    search:'',
                    creator:'',
                    pn:1,
                    rn:30,
                },
                totalCnt:0,
                creatorList:[],
                tableHeight:300,
                dataList:[],
                actionLevel1Tag:{
                    dimension_id:'',
                    dimension_name:'',
                    id:'',
                    name:'',
                    max_allow_num:'',
                },
            }
        },
        computed:{

        },
        created(){
            this.getLevel1List();
            this.getCreatorList();
        },
        mounted(){
            this.calcTableHeight();
        },
        watch:{

        },
        beforeDestroy(){
            window.removeEventListener("resize", this.calcTableHeight);
        },
        methods:{
            calcTableHeight(){
                let $filterBar = document.querySelector('.filter-bar');
                let filterBarHeight = $filterBar?$filterBar.clientHeight:0;
                let height = window.innerHeight - 70 - filterBarHeight - 45 - 52 - 50;
                this.$nextTick(()=>{
                    this.tableHeight = height;
                })
            },
            getLevel1List(){
                this.level1Loading = true;
                API.getLevel1List().then(res=>{
                    console.log('getLevel1List',res);
                    this.level1Loading = false;
                    this.level1List = (res.data||[]).map(item=>{
                        let child = item.children||[];
                        item.children = child.map(inner=>{
                            inner.dimension_id = item.id;
                            inner.dimension_name = item.name;
                            return inner;
                        });
                        return item;
                    });

                    let childList = [];
                    this.level1List.forEach(item=>{
                        childList = childList.concat(item.children||[]);
                    });
                    console.log('childList',childList);
                    if(childList.length>0){
                        this.activeLevel1Tag = childList[0];
                        this.getDataList();
                    }


                },err=>{
                    this.level1Loading = false;
                    this.$message.error(err.info||'请求失败');
                    this.level1List = [];
                })
            },
            editLevel1Tag(item,inner){
                console.log('editLevel1Tag',item,inner);
                this.actionLevel1Tag = {
                    dimension_id:item.id,
                    dimension_name:item.name,
                    id:inner.id,
                    name:inner.name,
                    max_allow_num:+inner.max_allow_num,
                };
                this.$refs.editLevel1TagModal.showModal();
            },
            updateLevel1Tag(num){
                let level1Group = this.level1List.find(item=>item.id==this.actionLevel1Tag.dimension_id)||{};
                let level1Item = (level1Group.children||[]).find(item=>item.id==this.actionLevel1Tag.id);
                if(level1Item){
                    level1Item.max_allow_num = num;
                }
            },
            changeLevel1Tag(item,inner){
                console.log('activeLevel1Tag',item,inner);
                this.activeLevel1Tag = inner;
                this.submitSearch();
            },
            submitSearch(){
                console.log('submitSearch');
                matomoFun.trackEvent('标签管理(标签维护)', '点击', '子标签查询');
                this.queryData.pn = 1;
                this.queryData.search = this.tempQuery.search;
                this.getDataList();
            },
            getDataList(){
                this.dataLoading = true;
                API.getLevel2List({
                    level1_id: this.activeLevel1Tag.id,
                    search: this.queryData.search,
                    creator: this.queryData.creator,
                    pn:this.queryData.pn,
                    rn:this.queryData.rn,
                }).then(res => {
                    let resData = res.data || {};
                    this.dataLoading = false;
                    this.dataList = resData.list||[];
                    let baseIndex = this.queryData.rn * (this.queryData.pn-1);
                    this.dataList = (resData.list || []).map((item,index)=>{
                        item.index = baseIndex+index+1;
                        return item;
                    });
                    this.totalCnt = resData.totalCnt;
                }, (err) => {
                    console.log('getUserList error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                    this.totalCnt = 0;
                });
            },
            getCreatorList(){
                API.getCreatorList().then(res=>{
                    this.creatorList = res.data||[];
                },err=>{
                    console.log('getCreatorList err',err);
                    this.$message.error(err.info||'请求失败');
                    this.creatorList = [];
                })
            },
            showAddLevel2TagModal(){
                console.log('showAddLevel2TagModal');
                this.$refs.addLevel2TagModal.showModal();


            },
            editLevel2Tag(row){
                console.log('editLevel2Tag',row);
                this.activeLevel2Tag = {
                    dimension_id:row.dimension_id,
                    dimension_name:row.dimension_name,
                    level1_id:row.level1_id,
                    level1_name:row.level1_name,
                    id:row.id,
                    name:row.name,
                };
                this.$refs.editLevel2TagModal.showModal();
            },
            cancelDelLevel2Tag(){
                matomoFun.trackEvent('标签管理(标签维护)', '点击', '删除子标签(取消)');
            },
            delLevel2Tag(row){
                console.log('delLevel2Tag',row);
                matomoFun.trackEvent('标签管理(标签维护)', '点击', '删除子标签(确定)');
                API.deleteLevel2Tag({
                    level1_id:row.level1_id,
                    level2_id:row.id,
                }).then(res=>{
                    this.$message.success(res.info || '操作成功');
                    this.getDataList();
                },err=>{
                    console.log('deleteYYLog error', err);
                    this.$message.error(err.info || '操作失败');
                })
            },
            handleSizeChange(val) {
                this.queryData.rn = val;
                this.getDataList();
            },
            handleCurrentChange(val) {
                this.queryData.pn = val;
                this.getDataList();
            },
        }
    }
</script>

<style lang="scss" scoped>
    .wrap {
        display: flex;
    }

    .left {
        width: 220px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-y: auto;
        flex:0 0 220px;
        .level1-wrap{
            padding:10px;
            min-height: 300px;

            .level-title{
                line-height: 26px;
                height: 26px;
            }
            .edit-icon{
                position: absolute;
                right: 5px;
                top: 6px;
                display: none;
                cursor: pointer;
            }

            .level-item{
                line-height: 26px;
                height: 26px;
                color: #606266;


                &.active{
                    background-color: #cfe6ff!important;
                    color: #409eff;
                }
                &:hover {
                    background-color: #e8eaec;
                    color: #409eff;
                    .edit-icon{
                        display: inline-block;
                    }
                }
            }

        }
    }
    .right {
        background-color: #fff;
        margin-left: 10px;
        flex: 1;

        .filter-bar{
            background-color: #f8f8f9;
            padding: 12px 20px 0;
            border-radius: 5px;
            ::v-deep .el-form-item{
                margin-bottom: 12px;
            }
        }

        .action-btn{
            margin: 6px;
        }
    }

</style>
